<script setup lang="ts">
import { useMyFetch } from '@/utils'
import OrganizationCard from '@/components/OrganizationCard.vue'
import { useAllStores } from '@/store'
import { handleError } from '@/utils/errors'

const { organizationStore, alertStore, authStore, router, t } = useAllStores()
const { data, error } = await useMyFetch('organizations').get().json()
await handleError(error, router, authStore, alertStore)

function hasNoOrganizations() {
  return !data.value || data.value.length === 0
}
</script>

<i18n lang="yaml">
en:
  register: 'Register organization'
  not_found: 'No organizations found. Create one:'
ru:
  register: 'Новая организация'
  not_found: 'Организации не найдены. Зарегистрируйте новую:'
</i18n>

<template>
  <div class="row mb-2">
    <div class="col">
      <h1 v-if="hasNoOrganizations()" class="mb-2">{{ t('not_found') }}</h1>
      <router-link
        class="btn btn-outline-primary me-2"
        :class="{ 'btn-lg': hasNoOrganizations() }"
        :to="{ name: 'organizations:add' }"
        ><img src="@/assets/plus.svg" />{{ t('register') }}</router-link
      >

      <!-- TODO implement filtering-->
      <div v-if="false" class="btn-group" role="group" aria-label="Basic radio toggle button group">
        <input
          type="radio"
          class="btn-check"
          name="btnradio"
          id="btnradio0"
          autocomplete="off"
          checked
        />
        <label class="btn btn-outline-primary" for="btnradio0">All</label>

        <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" />
        <label class="btn btn-outline-primary" for="btnradio1">Owner</label>

        <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" />
        <label class="btn btn-outline-primary" for="btnradio2">Admin</label>

        <input type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off" />
        <label class="btn btn-outline-primary" for="btnradio3">User</label>
      </div>
    </div>
  </div>
  <div class="row row-cols-1 row-cols-md-2 row-cols-xl-2 g-4">
    <div class="col" v-for="organization in data" :key="organization.id">
      <OrganizationCard
        :id="organization.id"
        :title="organization.name"
        :role="organization.role"
        :members="organization.members"
        :servers="organization.servers"
        :selected="organization.id === organizationStore.organization.id"
      />
    </div>
  </div>
</template>
